
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]",
      function () {
        return require("private-next-pages/[ssgParams]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]"])
      });
    }
  